import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutePath } from 'src/app/enums/route-path.enum';

@Component({
    selector: 'app-thematic-areas',
    templateUrl: './thematic-areas.component.html',
    styleUrls: ['./thematic-areas.component.scss'],
    standalone: false
})
export class ThematicAreasComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}

  goToESGArea(): void {
    this.router.navigate([RoutePath.THEMATIC_AREA, RoutePath.ESG]);
  }
  goToCybersecurityArea(): void {
    this.router.navigate([RoutePath.THEMATIC_AREA, RoutePath.CYBERSECURITY]);
  }
  goToTransEnergeticaArea(): void {
    this.router.navigate([RoutePath.THEMATIC_AREA, RoutePath.ENERGETIC]);
  }
  goToTransDigitaleArea(): void {
    this.router.navigate([RoutePath.THEMATIC_AREA, RoutePath.DIGITAL]);
  }
}
